module.exports = __webpack_public_path__ + "static/media/icono_otros.9052f5f8.svg";